app.controller("customFormController", [
    "$scope",
    "$stateParams",
    "PatientFormsAPI",
    function ($scope, $stateParams, PatientFormsAPI) {
        $scope.PatientFormsAPI = PatientFormsAPI;
        $scope.token = $stateParams.token;
        $scope.isValidToken = false;
        $scope.statusText = "Incorrect";
        $scope.verifyData = null;
        $scope.formTemplate = null;
        $scope.formComponents = [];
        $scope.auth = {
            dob: "",
        };

        /* Three selects rather than <input type="date">. A native picker opens on the
           current month, so a patient born in 1938 has to page back a thousand times or
           know they can click the year; a year list that starts at today and runs back
           120 years is two scrolls. The day list is rebuilt from the chosen month so
           31 February cannot be picked at all. */
        var DOB_MONTHS = [
            { value: 1, label: "January" },
            { value: 2, label: "February" },
            { value: 3, label: "March" },
            { value: 4, label: "April" },
            { value: 5, label: "May" },
            { value: 6, label: "June" },
            { value: 7, label: "July" },
            { value: 8, label: "August" },
            { value: 9, label: "September" },
            { value: 10, label: "October" },
            { value: 11, label: "November" },
            { value: 12, label: "December" },
        ];

        $scope.dobMonths = DOB_MONTHS;
        $scope.dobParts = { day: null, month: null, year: null };

        $scope.dobYears = (function () {
            var thisYear = new Date().getFullYear();
            var years = [];
            for (var year = thisYear; year >= thisYear - 120; year--) {
                years.push(year);
            }
            return years;
        })();

        function daysInMonth(month, year) {
            if (!month) return 31;
            // Day 0 of the next month is the last day of this one, and it accounts for
            // leap years on its own.
            return new Date(year || 2000, month, 0).getDate();
        }

        function rebuildDobDays() {
            var count = daysInMonth($scope.dobParts.month, $scope.dobParts.year);
            var days = [];
            for (var day = 1; day <= count; day++) {
                days.push(day);
            }
            $scope.dobDays = days;

            // 31 January -> February leaves the day out of range; drop it rather than
            // silently rolling the date into March.
            if ($scope.dobParts.day > count) {
                $scope.dobParts.day = null;
            }
        }

        function pad2(value) {
            return String(value).length < 2 ? "0" + value : String(value);
        }

        $scope.onDobChanged = function () {
            rebuildDobDays();

            var parts = $scope.dobParts;
            if (!parts.day || !parts.month || !parts.year) {
                $scope.auth.dob = "";
                return;
            }

            $scope.auth.dob = parts.year + "-" + pad2(parts.month) + "-" + pad2(parts.day);
        };

        rebuildDobDays();
        $scope.answers = {
            text: {},
            single: {},
            multi: {},
            // Free text typed against an "Other" option, keyed by question.
            other: {},
        };
        $scope.submitState = {
            success: "",
            error: "",
        };
        $scope.isSubmitted = false;

        function normalizeValue(value) {
            return String(value || "").trim().toLowerCase();
        }

        function normalizeId(value) {
            if (value === null || value === undefined) return "";
            return String(value).trim();
        }

        function idsMatch(left, right) {
            var leftText = normalizeId(left);
            var rightText = normalizeId(right);

            if (leftText === rightText) {
                return true;
            }

            var leftNumber = Number(leftText);
            var rightNumber = Number(rightText);
            if (!Number.isNaN(leftNumber) && !Number.isNaN(rightNumber)) {
                return leftNumber === rightNumber;
            }

            return false;
        }

        function getConditionOptionIds(condition) {
            if (!condition) return [];

            var optionIds = condition.optionIds !== undefined ? condition.optionIds : condition.option_ids;

            if (Array.isArray(optionIds)) {
                return optionIds;
            }

            if (typeof optionIds === "number") {
                return [optionIds];
            }

            if (typeof optionIds === "string") {
                var text = optionIds.trim();
                if (!text) return [];
                if (text.indexOf(",") > -1) {
                    return text.split(",").map(function (part) {
                        return part.trim();
                    }).filter(function (part) {
                        return !!part;
                    });
                }
                return [text];
            }

            return [];
        }

        /* Components come back camelCase and the envelope snake_case: the RAML marks
           components "existingJavaType", so Jackson binds them to the hand-written
           services classes, which have no @JsonProperty. Only the generated envelope
           (component_id, answer_component, custom_form_answers) is snake_case. */
        $scope.componentId = function (component) {
            if (!component) return null;
            return component.componentId !== undefined ? component.componentId : component.component_id;
        };

        $scope.optionText = function (option) {
            if (!option) return "";
            var text = option.textContent !== undefined ? option.textContent : option.text_content;
            return text ? String(text) : "";
        };

        $scope.optionAltText = function (option) {
            if (!option) return "";
            var alt = option.altText !== undefined ? option.altText : option.alt_text;
            return alt ? String(alt) : "";
        };

        $scope.optionIsImage = function (option) {
            return !!$scope.optionAltText(option) && !$scope.optionText(option);
        };

        $scope.optionLabel = function (option) {
            return $scope.optionText(option) || $scope.optionAltText(option);
        };

        function questionText(component) {
            if (!component) return "";
            var text = component.questionText !== undefined ? component.questionText : component.question_text;
            return text ? String(text) : "";
        }

        $scope.questionText = questionText;

        function headerText(component) {
            if (!component) return "";
            return component.headerText || component.header_text || "";
        }

        $scope.headerText = headerText;

        function bodyText(component) {
            if (!component) return "";
            return component.textContent || component.text_content || "";
        }

        $scope.bodyText = bodyText;

        $scope.getComponentKey = function (component, index) {
            var id = $scope.componentId(component);
            if (id !== undefined && id !== null) {
                return String(id);
            }
            return "idx-" + index;
        };

        $scope.getQuestionOptions = function (component) {
            if (!component) return [];
            var options = component.questionOptions || component.question_options;
            if (!Array.isArray(options)) return [];
            return options.filter(function (option) {
                return option && ($scope.optionText(option) || $scope.optionAltText(option));
            });
        };

        $scope.isQuestionComponent = function (component) {
            return !!questionText(component);
        };

        $scope.isHeaderComponent = function (component) {
            return !!headerText(component);
        };

        $scope.isTextComponent = function (component) {
            return !!(bodyText(component) && !questionText(component) && !headerText(component));
        };

        /* A picture shown on its own, not as an answer option: alt text or a stored
           file, and nothing of a question. */
        $scope.isImageComponent = function (component) {
            if (!component || questionText(component) || $scope.getQuestionOptions(component).length) return false;
            return !!($scope.optionAltText(component) || component.image);
        };

        /* Derived from the options alone. Nothing on the wire says "this is an image
           question" - a question whose options all carry alt_text is one. */
        $scope.getQuestionType = function (component) {
            if (!component) return "freeText";

            var options = $scope.getQuestionOptions(component);
            var displayStyle = component.displayStyle || component.display_style;

            if (options.length > 0 && options.every($scope.optionIsImage)) {
                return "imageChoice";
            }

            if (displayStyle === "CHECKBOX" || component.allow_multiple_selections || component.allowMultipleSelections) {
                return "multipleChoice";
            }

            if (options.length > 0) {
                return "singleChoice";
            }

            return "freeText";
        };

        /* "Other" is the last text option, exactly as the builder wrote it. Picking it
           reveals a box; what is typed goes up as an answer_string on the question, next
           to the option's own answer_id. */
        var OTHER_OPTION_TEXT = "other";

        function otherOption(component) {
            var options = $scope.getQuestionOptions(component);
            if (!options.length) return null;

            var last = options[options.length - 1];
            return String($scope.optionText(last) || "").trim().toLowerCase() === OTHER_OPTION_TEXT
                ? last
                : null;
        }

        $scope.isOtherOption = function (component, option) {
            var other = otherOption(component);
            return !!other && $scope.componentId(other) === $scope.componentId(option);
        };

        $scope.isOtherActive = function (component, componentIndex) {
            var other = otherOption(component);
            if (!other) return false;

            var key = $scope.getComponentKey(component, componentIndex);
            var id = $scope.componentId(other);

            return $scope.getQuestionType(component) === "multipleChoice"
                ? $scope.isMultiSelected(key, id)
                : $scope.answers.single[key] === id;
        };

        $scope.isYesNoQuestion = function (component) {
            var options = $scope.getQuestionOptions(component);
            if (options.length !== 2) return false;

            return normalizeValue($scope.optionText(options[0])) === "yes"
                && normalizeValue($scope.optionText(options[1])) === "no";
        };

        /* Token-scoped and unauthenticated, so this can be an <img src> directly - but
           only when the option actually has a stored file. An option whose upload never
           completed has no image, and the endpoint answers 500, which the browser would
           render as a broken image on a patient's screen. */
        $scope.optionImageUrl = function (option) {
            if (!option || !option.image) return "";
            return $scope.PatientFormsAPI.getPatientComponentImageUrl($scope.token, $scope.componentId(option));
        };

        $scope.optionImageMissing = function (option) {
            return $scope.optionIsImage(option) && !(option && option.image);
        };

        $scope.toggleMultiOption = function (componentKey, optionId) {
            if (!$scope.answers.multi[componentKey]) {
                $scope.answers.multi[componentKey] = {};
            }

            var optionKey = normalizeId(optionId);
            $scope.answers.multi[componentKey][optionKey] = !$scope.answers.multi[componentKey][optionKey];
        };

        $scope.isMultiSelected = function (componentKey, optionId) {
            var optionKey = normalizeId(optionId);
            return !!($scope.answers.multi[componentKey] && $scope.answers.multi[componentKey][optionKey]);
        };

        function getSelectedOptionIds(component, componentIndex) {
            if (!component) return [];

            var key = $scope.getComponentKey(component, componentIndex);
            var type = $scope.getQuestionType(component);

            if (type === "multipleChoice") {
                var selectedMap = $scope.answers.multi[key];
                if (!selectedMap) return [];

                return Object.keys(selectedMap).filter(function (optionId) {
                    return !!selectedMap[optionId];
                });
            }

            if (type === "singleChoice" || type === "imageChoice") {
                var selectedSingle = $scope.answers.single[key];
                if (!selectedSingle) return [];
                return [selectedSingle];
            }

            return [];
        }

        function isQuestionAnswered(component, componentIndex) {
            if (!component) return false;

            var key = $scope.getComponentKey(component, componentIndex);
            var type = $scope.getQuestionType(component);

            if (type === "freeText") {
                return !!String($scope.answers.text[key] || "").trim();
            }

            if (type === "multipleChoice") {
                var selectedMap = $scope.answers.multi[key];
                var anySelected = !!(selectedMap && Object.keys(selectedMap).some(function (optionId) {
                    return !!selectedMap[optionId];
                }));
                if (!anySelected) return false;
                // Picking "Other" and leaving the box empty is not an answer.
                if ($scope.isOtherActive(component, componentIndex)) {
                    return !!String($scope.answers.other[key] || "").trim();
                }
                return true;
            }

            if (!normalizeId($scope.answers.single[key])) return false;
            if ($scope.isOtherActive(component, componentIndex)) {
                return !!String($scope.answers.other[key] || "").trim();
            }
            return true;
        }

        function clearAnswerForComponent(component, componentIndex) {
            var key = $scope.getComponentKey(component, componentIndex);
            if (Object.prototype.hasOwnProperty.call($scope.answers.text, key)) {
                delete $scope.answers.text[key];
            }
            if (Object.prototype.hasOwnProperty.call($scope.answers.single, key)) {
                delete $scope.answers.single[key];
            }
            if (Object.prototype.hasOwnProperty.call($scope.answers.multi, key)) {
                delete $scope.answers.multi[key];
            }
            if (Object.prototype.hasOwnProperty.call($scope.answers.other, key)) {
                delete $scope.answers.other[key];
            }
        }

        function evaluateVisibilityCondition(condition, sourceComponent, sourceIndex) {
            if (!condition || !sourceComponent) return false;

            var operator = condition.operator || "EQUALS";
            if (operator === "IS_ANSWERED") {
                return isQuestionAnswered(sourceComponent, sourceIndex);
            }

            if (operator === "EQUALS") {
                var selectedOptionIds = getSelectedOptionIds(sourceComponent, sourceIndex);
                var conditionOptionIds = getConditionOptionIds(condition);
                if (conditionOptionIds.length === 0) return false;

                return conditionOptionIds.some(function (conditionOptionId) {
                    return selectedOptionIds.some(function (selectedOptionId) {
                        return idsMatch(conditionOptionId, selectedOptionId);
                    });
                });
            }

            return false;
        }

        $scope.isComponentVisible = function (component, componentIndex, allComponents) {
            var conditions = component
                ? (component.visibilityConditions || component.visibility_conditions)
                : null;
            if (!Array.isArray(conditions) || conditions.length === 0) {
                return true;
            }

            var components = Array.isArray(allComponents) ? allComponents : [];
            var conditionResults = conditions.map(function (condition) {
                var conditionSourceId = condition
                    ? (condition.sourceComponentId !== undefined ? condition.sourceComponentId : condition.source_component_id)
                    : null;
                if (conditionSourceId === undefined || conditionSourceId === null) {
                    return false;
                }

                var sourceIndex = -1;
                var sourceComponent = components.find(function (candidate, idx) {
                    var matches = candidate && String($scope.componentId(candidate)) === String(conditionSourceId);
                    if (matches) {
                        sourceIndex = idx;
                    }
                    return matches;
                });

                return evaluateVisibilityCondition(condition, sourceComponent, sourceIndex);
            });

            var isVisible = (component.visibilityLogic || component.visibility_logic) === "ANY"
                ? conditionResults.some(function (value) { return !!value; })
                : conditionResults.every(function (value) { return !!value; });

            if (!isVisible) {
                clearAnswerForComponent(component, componentIndex);
            }

            return isVisible;
        };

        $scope.getAnswerSnapshot = function () {
            return {
                dob: $scope.auth.dob,
                text: angular.copy($scope.answers.text),
                single: angular.copy($scope.answers.single),
                multi: angular.copy($scope.answers.multi),
                other: angular.copy($scope.answers.other),
            };
        };

        function toNumberIfNumeric(value) {
            var text = normalizeId(value);
            if (!text) return value;
            var parsed = Number(text);
            return Number.isNaN(parsed) ? value : parsed;
        }

        function buildSubmitAnswers() {
            var payloadAnswers = [];

            ($scope.formComponents || []).forEach(function (component, componentIndex) {
                if (!$scope.isQuestionComponent(component)) {
                    return;
                }

                if (!$scope.isComponentVisible(component, componentIndex, $scope.formComponents)) {
                    return;
                }

                var componentId = toNumberIfNumeric($scope.componentId(component));
                var key = $scope.getComponentKey(component, componentIndex);
                var questionType = $scope.getQuestionType(component);

                /* An "Other" selection is two entries on the same question: the option's
                   own answer_id, plus an answer_string carrying what was typed. The answer
                   list already holds several entries per question for multi-select, so this
                   needs nothing new from the API. */
                function pushOtherText() {
                    if (!$scope.isOtherActive(component, componentIndex)) return;

                    var typed = String($scope.answers.other[key] || "").trim();
                    if (!typed) return;

                    payloadAnswers.push({
                        component_id: componentId,
                        answer_component: {
                            answerString: typed,
                        },
                    });
                }

                // The image types are choice questions whose options happen to be pictures.
                if (questionType === "singleChoice" || questionType === "imageChoice") {
                    var answerId = $scope.answers.single[key];
                    if (normalizeId(answerId)) {
                        payloadAnswers.push({
                            component_id: componentId,
                            answer_component: {
                                answerId: toNumberIfNumeric(answerId),
                            },
                        });
                        pushOtherText();
                    }
                    return;
                }

                if (questionType === "multipleChoice") {
                    var selectedMap = $scope.answers.multi[key] || {};
                    Object.keys(selectedMap).forEach(function (optionId) {
                        if (!selectedMap[optionId]) {
                            return;
                        }
                        payloadAnswers.push({
                            component_id: componentId,
                            answer_component: {
                                answerId: toNumberIfNumeric(optionId),
                            },
                        });
                    });
                    pushOtherText();
                    return;
                }

                if (questionType === "freeText") {
                    var textAnswer = String($scope.answers.text[key] || "").trim();
                    if (textAnswer) {
                        payloadAnswers.push({
                            component_id: componentId,
                            answer_component: {
                                answerString: textAnswer,
                            },
                        });
                    }
                }
            });

            return payloadAnswers;
        }

        function validateBeforeSubmit() {
            if (!$scope.auth.dob) {
                return "Date of Birth is required.";
            }

            var missingRequired = ($scope.formComponents || []).some(function (component, componentIndex) {
                if (!$scope.isQuestionComponent(component) || !component.required) {
                    return false;
                }
                if (!$scope.isComponentVisible(component, componentIndex, $scope.formComponents)) {
                    return false;
                }
                return !isQuestionAnswered(component, componentIndex);
            });

            if (missingRequired) {
                return "Please answer all required questions.";
            }

            return "";
        }

        $scope.submitAnswers = function () {
            $scope.submitState.success = "";
            $scope.submitState.error = "";

            var validationError = validateBeforeSubmit();
            if (validationError) {
                $scope.submitState.error = validationError;
                return;
            }

            var payload = {
                custom_form_answers: {
                    answers: buildSubmitAnswers(),
                },
            };

            $scope.PatientFormsAPI.isProcessing = true;
            $scope.PatientFormsAPI.submitPatientCustomFormByToken($scope.token, $scope.auth.dob, payload)
                .then(function () {
                    $scope.submitState.success = "Submitted successfully.";
                    $scope.isSubmitted = true;
                })
                .catch(function () {
                    $scope.submitState.error = "We couldn't submit your answers. Please check your date of birth is correct, then try again.";
                })
                .finally(function () {
                    $scope.PatientFormsAPI.isProcessing = false;
                });
        };

        function loadFormByToken() {
            $scope.PatientFormsAPI.isProcessing = true;
            $scope.PatientFormsAPI.verifyToken($scope.token)
                .then(function (resp) {
                    var data = resp && resp.data ? resp.data : {};
                    var template = data.form_template || null;

                    $scope.verifyData = data;
                    $scope.formTemplate = template;
                    $scope.formComponents = template && Array.isArray(template.components)
                        ? template.components.slice().sort(function (a, b) {
                            var ao = a.orderIndex !== undefined ? a.orderIndex : a.order_index;
                            var bo = b.orderIndex !== undefined ? b.orderIndex : b.order_index;
                            return Number(ao || 0) - Number(bo || 0);
                        })
                        : [];

                    $scope.isValidToken = true;
                    $scope.statusText = "welcome";
                })
                .catch(function () {
                    $scope.isValidToken = false;
                    $scope.statusText = "Incorrect";
                })
                .finally(function () {
                    $scope.PatientFormsAPI.isProcessing = false;
                });
        }

        if (!$scope.token) {
            $scope.statusText = "Incorrect";
            return;
        }

        loadFormByToken();
    },
]);
